import { Component } from 'react';
import AdminTable from 'layouts/AdminTable';
import withStyles from '@material-ui/core/styles/withStyles';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle';
import DataGrid from 'components/DataGrid/DataGrid';
import DataGridStateContextProvider from 'components/DataGrid/DataGridStateContext';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';

import columnConfig from './columnConfig';

class List extends Component {
  render() {
    return (
      <DataGridStateContextProvider>
        <AdminTable title={this.props.t('comments.commentsList')}>
          <DataGrid
            remove={true}
            export={true}
            paginationTop={true}
            paginationBottom={false}
            url="/rates"
            reportName="rate"
            columns={columnConfig(this.props.t)}
            role="RATE"
            minRows={20}
            manipulateQuery={(_, query) => {
              // eslint-disable-next-line no-underscore-dangle -- FIXME
              query._orX = [];

              if (query.createdAt) {
                const filters = query.createdAt;

                if (filters.after) {
                  query['createdAt[after]'] = filters.after;
                }

                if (filters.before) {
                  query['createdAt[before]'] = filters.before;
                }

                delete query.createdAt;
              }

              if (query.user) {
                const splicedName = query.user.split(' ');

                if (splicedName.length === 1) {
                  // eslint-disable-next-line no-underscore-dangle -- FIXME
                  query._orX.push([
                    {
                      'client.firstName': query.user,
                      'client.lastName': query.user,
                    },
                  ]);
                } else if (splicedName.length === 2) {
                  // eslint-disable-next-line no-underscore-dangle -- FIXME
                  query._orX.push(
                    [
                      {
                        'client.firstName': splicedName[0],
                      },
                    ],
                    [
                      {
                        'client.lastName': splicedName[1],
                      },
                    ]
                  );
                } else {
                  // eslint-disable-next-line no-underscore-dangle -- FIXME
                  query._orX.push([
                    {
                      'client.firstName': splicedName,
                      'client.lastName': splicedName,
                    },
                  ]);
                }

                delete query.user;
              }

              if (query.diet) {
                query['bag.diet.name'] = query.diet;

                delete query.diet;
              }

              return query;
            }}
          />
        </AdminTable>
      </DataGridStateContextProvider>
    );
  }
}
const enhance = compose(withTranslation(), withStyles(buttonsStyle));

export default enhance(List);
